import Vue from 'vue';
import Vuex from 'vuex';

import Component from 'vue-class-component';

function changeAccessSave(){
    var taskInput = document.getElementById('task');
    var buttonAccess = document.getElementById('buttonSave');
    var hours = document.getElementById('count_hours');
    var minutes = document.getElementById('count_minutes');


    if ((hours.value != 0 || minutes.value != 0) && taskInput.selectedIndex != 0){
        buttonAccess.classList.add('accessButton');
    }
    else {
        if(buttonAccess.classList.contains('accessButton')){
            buttonAccess.classList.remove('accessButton');
        }
    }

}

@Component
export default class TimeTracking extends Vue {
    constructor() {
        super();
        this.container = null;
        this.postData = {
            project: "",
            task : "",
            date : null,
            count: 0,
            status: "",
            comm_made: "",
            comm_whatremains : "",
            comm_howmuch : "",
            comm_problems : ""
        };
        this.title = "";
        this.hours = 0;
        this.minutes = 0;
        this.count_remaining = 0;
        this.isJiraTask = true;
        this.from = "";
        this.old_status = "";
        this.old_hours = 0;
        this.is_inside = "";

    }

    created() {
        this.container = this.$attrs.container;
        this.$data.postData.project = this.container.items.id;
        this.$data.is_inside = this.container.items.is_inside;
        this.$data.postData.date = this.container.getDateForPost(this.container.items.day);
    }
    beforeUpdate(){
        this.container.setTasks(this.container.items.id, this.container.items.jira_id);

        if (document.getElementById("task").selectedIndex == 0) {
            document.getElementById("status").disabled = true;
            document.getElementById("comm_howmuch").disabled = true;
        }

    }
    beforeDestroy(){
        this.container.updateReport();
        this.container.updateTasks(this.container.items.id, this.container.items.jira_id);
    }
    handleClickModal(e) {
        this.$modal.hide('time-tracking');
    }
    handleChange(e, field) {
        if (field == "hours" || field =="minutes"){
            this.$data[field] = e.target.value;
            changeAccessSave();
        }
        else{
            this.$data.postData[field] = e.target.value;
        }
    }
    buttonClick(e) {
        let task_select_form = document.getElementById("task").options[document.getElementById("task").selectedIndex].value;
        if (task_select_form){
            task_select_form = JSON.parse(task_select_form);
        }
        else{
            this.$data.postData.task = "";
        }
        this.$data.postData.task = task_select_form.monoceros;
        this.$data.postData.status = {
            new: document.getElementById("status").options[document.getElementById("status").selectedIndex].value,
            old: this.old_status
        };
        this.$data.postData.comm_howmuch = document.getElementById("comm_howmuch").options[document.getElementById("comm_howmuch").selectedIndex].value;
        this.postData.count = parseInt(this.hours) * 60 + parseInt(this.minutes);
        let difference = this.postData.count-this.$data.old_hours;
        this.container.postWriteOff(this.postData, this.container.items.id, this.container.items.jira_id, this.$data.is_inside, this.container.getTimeTracking(this.container.items.day), difference);
        this.$data.hours = 0;
        this.$data.minutes = 0;
        this.$data.count_remaining = 0;
        this.setInputField("count_hours", 0, "input");
        this.setInputField("count_minutes", 0, "input");
        document.getElementById("task").selectedIndex = 0;
        document.getElementById("status").selectedIndex = 0;
        document.getElementById("comm_howmuch").selectedIndex = 0;
        this.container.setTasks(this.container.items.id, this.container.items.jira_id);
        this.container.updateTasks(this.container.items.id, this.container.items.jira_id);
        this.container.updateReport();
        this.setInputField("comm_made", "", "input");
        this.setInputField("comm_whatremains", "", "input");
        this.setInputField("comm_problems", "", "input");
        this.$data.old_hours = 0;
    }
    issetTask(jira_id, list){
        let tasks = this.container.getWriteOffMonoceros(this.container.items.day);

        tasks.forEach(element => {
            if(jira_id == element.jira_task_id){
                list.task_id = element.task_id;
                // list.count = element.count;
                list.comm_howmuch = element.comm_howmuch;
                list.comm_problems = element.comm_problems;
                list.comm_whatremains = element.comm_whatremains;
                return;
            }
        });
    }
    clickTableRow(e, task_info, comment){
        this.changeTaskType(task_info.jira_task_id);
        this.clearForm();
        this.from = comment;
        this.issetTask(task_info.task_id, task_info);
        this.postData.track_id = task_info.track_id;
        //часы-минуты
        this.$data.postData.count = task_info.count;
        this.$data.old_hours = task_info.count;
        this.$data.hours = Math.floor(task_info.count / 60);
        this.$data.minutes = task_info.count % 60;
        this.setInputField("count_hours", this.$data.hours , "select");
        this.setInputField("count_minutes", this.$data.minutes, "select");
        //оставшееся на задачу время
        this.$data.count_remaining = task_info.count_remaining;
        this.setInputField("count_remaining", task_info.count_remaining, "input");
        //статус
        this.old_status = task_info.status;
        this.setInputField("status", task_info.status, "select");
        //задача
        this.$data.postData.task = [task_info.task_id, task_info.task_title];

        let task_list = document.getElementById("task").options;
        for (let i = 0; i < task_list.length; i++) {
            if (task_list[i].value) {
                if (JSON.parse(task_list[i].value).monoceros == task_info.task_id) {
                    task_list[i].selected = true;
                }
                if (JSON.parse(task_list[i].value).jira == task_info.task_id) {
                    task_list[i].selected = true;
                }
            }
        }
        //что сделано
        this.$data.postData.comm_made = task_info.comm_made
        this.setInputField("comm_made", this.$data.postData.comm_made, "input");
        //сколько осталось
        this.$data.postData.comm_howmuch = task_info.comm_howmuch;
        this.setInputField("comm_howmuch", this.$data.postData.comm_howmuch, "select");
        //что осталось
        this.$data.postData.comm_whatremains = task_info.comm_whatremains
        this.setInputField("comm_whatremains", this.$data.postData.comm_whatremains, "input");
        //проблемы
        this.$data.postData.comm_problems = task_info.comm_problems
        this.setInputField("comm_problems", this.$data.postData.comm_problems, "input");
        if(comment == "jira"){
            this.setDisabledOnFields(true);
        } else if (comment == "monoceros"){
            this.setDisabledOnFields(false);
        }

        this.changeAvailabilityStatusList(task_list[document.getElementById("task").selectedIndex]);
        this.changeAvailabilityHowMuchField();
    }
    setDisabledOnFields(is_disabled){
        document.getElementById("count_hours").disabled = is_disabled;
        document.getElementById("count_minutes").disabled = is_disabled;
        document.getElementById("task").disabled = is_disabled;
        document.getElementById("status").disabled = is_disabled;
        document.getElementById("comm_made").disabled = is_disabled;
    }
    clearForm(){
        this.$data.hours = 0;
        this.setInputField("count_hours", 0, "input");
        this.$data.minutes = 0;
        this.setInputField("count_minutes", 0, "input");
        this.$data.postData.task = "";
        document.getElementById("task").selectedIndex = 0;
        this.$data.postData.status = "";
        document.getElementById("status").selectedIndex = 0;
        this.$data.count_remaining = 0;
        this.setInputField("count_remaining", 0, "input");
        this.$data.postData.comm_howmuch = "";
        this.setInputField("comm_howmuch", "", "input");
        this.$data.postData.comm_made = "";
        this.setInputField("comm_made", "", "input");
        this.$data.postData.comm_whatremains = "";
        this.setInputField("comm_whatremains", "", "input");
        this.$data.postData.comm_problems = "";
        this.setInputField("comm_problems", "", "input");
        this.setDisabledOnFields(false);
        this.$data.postData.track_id = "";
    }
    setInputField(field, data, type){
        if(type=="select"){
            let list = document.getElementById(field).options;
            for (let i = 0; i < list.length; i++) {
                if (list[i].value == data && field!="status") {
                    list[i].selected = true;
                } else if (list[i].text == data && field=="status"){
                    list[i].selected = true;
                }
            }
        }
        if(type=="input"){
            document.getElementById(field).value = data;
        }
    }
    changeAvailabilityStatusList(selectedTask){
        if (JSON.parse(selectedTask.value).disabled_status == "true") {
            document.getElementById("status").disabled = true;
        } else {
            document.getElementById("status").disabled = false;
        }
    }

    /**
     * Меняет тип задачи jira/monoceros и в зависимости от нее
     * разрешает или запрещает редактировать задачу
     * @param isJiraTask - id задачи из jira
     */
    changeTaskType(isJiraTask){
      this.isJiraTask = !!isJiraTask;
      let buttonAccess = document.getElementById('buttonSave');
      let buttonWarning = document.getElementById('buttonWarning');
      if (this.isJiraTask) {
        buttonAccess.classList.add('hide');
        buttonWarning.classList.remove('hide');
      } else{
        buttonAccess.classList.remove('hide');
        buttonWarning.classList.add('hide');
      }
    }

    selectTaskListChanged(e){
        let index = e.target.selectedIndex;
        if(e.target.options[index].value !=0){
            let status = JSON.parse(e.target.options[index].value).status;
            let count_remaining = JSON.parse(e.target.options[index].value).count_remaining;
            this.changeTaskType(JSON.parse(e.target.options[index].value).jira);
            this.changeAvailabilityStatusList(e.target.options[index]);
            this.$data.postData.status = status;
            this.setInputField("status", status, "select");
            this.$data.count_remaining = count_remaining;
            this.setInputField("count_remaining", count_remaining, "input");
            this.changeAvailabilityHowMuchField();
        }
        changeAccessSave();

    }
    changeAvailabilityHowMuchField(){
        if(this.$data.is_inside === true ||
            (this.$data.postData.status == "Cancelled" ||
            this.$data.postData.status == "Closed" ||
            this.$data.postData.status == "Done" ||
            this.$data.postData.status == "Resolved" ||
            this.$data.postData.status == "Test" )) {
                document.getElementById("comm_howmuch").disabled = true;
        } else {
            document.getElementById("comm_howmuch").disabled = false;
        }
    }
    render(h) {
        return (
            <div>
                <div class="outer-block h-100">
                    <div class="navbar">
                        <div style="font-size: 14pt;">{this.container.items.title}</div>
                        <div style="font-size: 12pt; ">{this.container.getDateForPost(this.container.items.day)}</div>
                        <div style="font-size: 20pt;"></div>
                        <div class="navbar-toggler-right">
                            <span onClick={(e) => { this.handleClickModal(e) }} class="oi float-right d-inline-block" style="font-size: 27pt;" data-glyph="x"></span>
                        </div>
                    </div>

                    <div class="mr-3 ml-3 mt-3 mb-0" style="height: 470px;">
                        {/* левый блок */}
                        <div class="d-inline-block float-left w-50 pr-4 inner-block mb-3">
                            <div class="inner-text mb-3 w-100">
                                <div class=" d-inline-block w-50">
                                    Часы:
                                    <select id="count_hours" class="ml-3 w-50 d-inline-block form-control form-control-sm"
                                        onChange={(e) => { this.handleChange(e, 'hours') }} value={this.$data.hours}
                                    >
                                        {Array.from({ length: 13 },
                                            (v, k) => k).map((index) => (
                                                <option value={index}>
                                                    {index}
                                                </option>
                                            ))}
                                    </select>
                                </div>
                                <div class=" d-inline-block  w-50 text-right">
                                    Минуты:
                                    <select id="count_minutes" class="ml-3 w-50 d-inline-block form-control form-control-sm"
                                        value={this.$data.minutes}
                                        onChange={(e) => { this.handleChange(e, 'minutes') }} value={this.$data.minutes}
                                    >
                                        {Array.from({ length: 13},
                                            (v,k) => k*5).map((index) => (
                                                <option value={index}>
                                                    {index}
                                                </option>
                                            ))}
                                    </select>
                                </div>
                            </div>
                            <div class="inner-text mb-3 form-inline d-block float-right w-100">
                                <div class="d-inline-block " >Задача: </div>
                                <select id="task" class="d-inline-block custom-select form-control-sm w-75 float-right"
                                        onChange={(e)=>{this.selectTaskListChanged(e)}}>
                                    {Array.from({ length: this.container.getAllTasks().length },
                                        (v, k) => k).map((index) => (

                                            <option style={this.container.getAllTasks()[index].hidden} value={
                                                '{"monoceros":'+this.container.getAllTasks()[index].task_id +', "jira":'+ this.container.getAllTasks()[index].jira_task_id+
                                                ', "status":"' + this.container.getAllTasks()[index].status + '", "disabled_status":"' + this.container.getAllTasks()[index].disabled_status+'", "count_remaining":'+this.container.getAllTasks()[index].count_remaining+'}'
                                            }>
                                                {this.container.getAllTasks()[index].jira_task_id == -1? "" : this.container.getAllTasks()[index].jira_task_id}  {this.container.getAllTasks()[index].task_title}
                                            </option>

                                        ))}
                                </select>

                            </div>
                            <div class="inner-text mb-2 form-inline d-block float-right w-100">
                                <div class="d-inline-block ">Статус: </div>
                                <select id="status" class="d-inline-block custom-select form-control-sm w-75 float-right">
                                    <option value=""></option>
                                    {Array.from({ length: this.container.getAllStatuses().length },
                                        (v, k) => k).map((index) => (
                                            <option value={this.container.getAllStatuses()[index].id}>
                                                {this.container.getAllStatuses()[index].title}
                                            </option>
                                    ))}
                                </select>
                            </div>
                            <div class="d-block w-100 d-block mb-2 float-right">
                                <div class="d-inline-block inner-text w-50" style="vertical-align: top;">
                                    <div class="" >Остаток часов: </div>
                                    <input value={this.$data.count_remaining} id="count_remaining" type="text" class="form-control form-control-sm w-75 text-left" disabled/>

                                </div>
                                <div class="d-inline-block inner-text w-50" >
                                    <div class="">Сколько осталось: </div>

                                    <select id="comm_howmuch" disabled="true" class="form-control form-control-sm w-100 text-left">
                                        <option value=""></option>
                                        {Array.from({ length: this.container.getCommHowMuch().length },
                                            (v, k) => k).map((index) => (
                                                <option value={this.container.getCommHowMuch()[index]}>
                                                    {this.container.getCommHowMuch()[index]}
                                                </option>
                                        ))}
                                    </select>
                                    {/* если вдруг снова нужен будет инпут вместо комбобокса
                                        <input
                                        type="text" id="comm_howmuch" class="form-control form-control-sm w-100 text-left"
                                        onChange={(e) => { this.handleChange(e, 'comm_howmuch') }} onKeyup={(e) => { this.handleChange(e, 'comm_howmuch') }}
                                    /> */}
                                </div>
                            </div>
                            <div class="inner-text mb-3 d-block float-right w-100">
                                <div class="">Что сделано: </div>
                                <textarea type="text" class="form-control textarea" id="comm_made"
                                    value={this.$data.postData.comm_made} onChange={(e) => { this.handleChange(e, 'comm_made') }} onKeyup={(e) => { this.handleChange(e, 'comm_made') }}
                                ></textarea>
                            </div>
                            <div class="inner-text mb-3 d-block float-right w-100">
                                <div class="">Что осталось: </div>
                                <textarea type="text" class="form-control textarea" id="comm_whatremains"
                                    value={this.$data.postData.comm_whatremains} onChange={(e) => { this.handleChange(e, 'comm_whatremains') }} onKeyup={(e) => { this.handleChange(e, 'comm_whatremains') }}
                                ></textarea>
                            </div>
                            <div class="inner-text mb-2 d-block float-right w-100">
                                <div class="">Проблемы: </div>
                                <textarea type="text" class="form-control textarea" id="comm_problems"
                                    value={this.$data.postData.comm_problems} onChange={(e) => { this.handleChange(e, 'comm_problems') }} onKeyup={(e) => { this.handleChange(e, 'comm_problems') }}
                                ></textarea>
                            </div>
                        </div>
                        {/* правый блок */}
                        <div class="d-inline-block float-left h-100 w-50 inner-block ">
                                <div class="text-center mb-1"> Списание в Моноцеросе</div>
                                <div class="table-head">
                                    <div class="table-columns m-1 time">
                                        Время
                                    </div>
                                    <div class="table-columns m-1 task-title-mono text-center" >
                                        Название задачи
                                    </div>
                                    <div class="table-columns m-1 step">
                                        Этап
                                    </div>
                                    <div class="table-columns m-1 task-status">
                                        Статус
                                    </div>
                                </div>
                                <div class="table-body">
                                    {Array.from({ length: this.container.getWriteOffMonoceros(this.container.items.day).length },
                                        (v, k) => k ).map((index) => (
                                    <div class="table-row"
                                        onClick={(e) => { this.clickTableRow(e,this.container.getWriteOffMonoceros(this.container.items.day)[index], "monoceros")}}
                                    >
                                        <div class="table-columns m-1 time">
                                            {Math.round(this.container.getWriteOffMonoceros(this.container.items.day)[index].count/60)!=0?
                                                        Math.round(this.container.getWriteOffMonoceros(this.container.items.day)[index].count / 60):""}
                                        </div>
                                        <div class="table-columns m-1 task-title-mono">
                                            {this.container.getWriteOffMonoceros(this.container.items.day)[index].task_title}
                                        </div>
                                        <div class="table-columns m-1 step">
                                        </div>
                                        <div class="table-columns m-1 task-status">
                                            {this.container.getWriteOffMonoceros(this.container.items.day)[index].status}
                                        </div>
                                    </div>
                                        ))}
                            </div>
                            <div class="mt-2" style="cursor: pointer;">
                                <span onClick={(e) => { this.clearForm() }}  class="oi" data-glyph="trash">Очистить формы </span>
                            </div>
                        </div>
                    </div>
                    <div class="m-0">
                        <button onClick={(e) => { this.buttonClick(e) }} type="button" class="btn btn-outline-secondary btn-save" id="buttonSave">Сохранить</button>
                        <button type="button" class="btn btn-warning btn-save" id="buttonWarning">Редактирование этого списания необходимо делать в Jira</button>
                    </div>
                </div>
                <style jsx>{`
                    @-moz-document url-prefix() {
                        .navbar{
                            height: 65px;
                        }
                    }               
                    .navbar{
                        background: #212223;
                        margin-bottom: 10px;
                        color: white; 
                    }
                    .btn-save{
                        font-size: 14pt; 
                        outline: none;
                        width: 100%;
                        border-radius: 0;
                    }
                    .table-row:hover{
                        background: #eceeef;
                    }
                    .time{
                        text-align: right;
                        width: 53px;
                        max-width: 53px;
                    }
                    .task-title-mono{
                        width: 260px;
                        max-width: 260px;
                    }
                    .task-title-jira{
                        padding-left: 5px;
                        width: 215px;
                        max-width: 215px;
                    }
                    .step{
                        width: 85px;
                        max-width: 85px;
                    }
                    .task-status{
                        width: 85px;
                        max-width: 85px;
                    }
                    .comment{
                        width: 255px;
                        max-width: 255px;
                    }
                    .table-head{
                        font-weight: 600;
                        display: block; 
                        font-size: 9pt;
                        border-bottom: 2px solid #e8f4ff7d;
                        background-color: #e8f4ff7d;

                    }
                    .table-body{
                        height: 370px;
                        display: block; 
                        font-size: 9pt;
                        overflow: auto;
                        cursor: pointer;
                    }
                    .table-columns{
                        font-size: 9pt;
                        display: inline-block;
                        word-wrap: normal;
                        vertical-align: top;
                    }
                    .table-row{
                        border-top: 1px solid #eceeef;
                        display: block; 
                    }

                    .btn{
                        border-radius: 0;
                    }
                    .btn-outline-secondary{
                        background-color: #e4e4e4; 
                        border-color: #e4e4e4;
                        color: #212223db;
                    }

                    .flt{
                        float: right;
                    }

                    .inner-text{
                        font-size: 10pt;
                    }

                    .navigation-icon-exit{
                        color: #373a3c;   
                        outline: 0;
                    }

                    a:hover {
                        text-decoration: none;
                        color: #818a91; 
                    } 

                    a:link{
                        text-decoration: none;
                    }
                    a:visited{
                        text-decoration: none;
                    }
                    a:active{
                        text-decoration: none;
                    }
                    .pad{
                        margin-right: 15px; 
                    }
                    textarea {
                        
                        //width: 200px; 
                        height: 68px; 
                        resize: none; 
                        overflow: auto;
                        wotd-wrap: normal;
                        
                    } 
                    textarea.form-control{
                        padding-top: 3px;
                        padding-right: 5px;
                        padding-bottom: 3px;
                        padding-left: 5px;
                        font-size: 12px;
                        font-family: 'Open Sans';
                    }
                    .wr-off-table{
                        min-height: 45%;
                        max-height: 45%;
                        overflow: auto;
                    }
                    .form-control:disabled {
                        cursor: default;
                    }
                    .custom-select:disabled{
                        cursor: default;
                    }
                    .accessButton{
                        background-color: #93c9f2; 
                        border-color: none;
                        color: #ffffff;
                        cursor: pointer;
                    }
                    .accessButton:hover{
                        background-color: #54a4f9;
                    }
                    .align-left{
                      text-align:left;
                    }
                    .align-center{
                      text-align: center;
                    }
                    .hide{
                      display: none;
                    }
                    #buttonWarning{
                      color: #000;
                    }
                `}</style>
            </div>
        );
    }
};



// WEBPACK FOOTER //
// ./src/TimeTrackingModal/TimeTracking.js